// extracted by mini-css-extract-plugin
export var modal = "SubmissionModal_modal__T6tJz";